import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faXmark,
    faThermometerHalf,
    faCamera,
    faPlus,
    faCheck,
    faClockRotateLeft,
    faTriangleExclamation,
    faList,
    faArrowLeft,
    faSnowflake,
    faFire,
    faRotateRight,
    faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";
library.add(
    faXmark,
    faThermometerHalf,
    faCamera,
    faPlus,
    faCheck,
    faClockRotateLeft,
    faTriangleExclamation,
    faList,
    faArrowLeft,
    faSnowflake,
    faFire,
    faRotateRight,
    faFloppyDisk,
)

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

createApp(App).component("font-awesome-icon", FontAwesomeIcon).use(store).use(router).mount('#app');
